import Box from "@mui/material/Box";
import { Button, ButtonGroup } from "@mui/material";
import { Navigate, Outlet, redirect, useLocation, useNavigate } from "react-router-dom";
import { PathtypesButtons } from "../../../constants/data_arrays";
import PathsView from "./PathsMain";


const PathsTypesLanding = () => {

    const location = useLocation()

    return (
        <Box sx={{
            padding: 1,
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            height: '100vh'
        }}>
            {location.pathname === "/" && <Navigate to="/paths" replace={true} />}
            <ButtonGroup sx={{justifyContent: "center", padding: 1}}>
            {PathtypesButtons.map((buttonLabel:any, i:any) => (
                <Button variant={ location.pathname === "/paths/"+ buttonLabel ? "contained" : "outlined" } href={"/paths/"+buttonLabel} key={i} name={buttonLabel}>
                  {buttonLabel}
               </Button>
              ))}
            </ButtonGroup>
            <Outlet />
        <PathsView />
            
        </Box>
    );
};

export default PathsTypesLanding;
